import { Directive, ElementRef, EventEmitter, HostListener, Input, Output, inject } from '@angular/core';

@Directive({
  selector: '[dstMatColumnResize]',
  standalone: false,
})
export class DstMatColumnResizeDirective {
  private readonly elementRef = inject(ElementRef<HTMLElement>);

  @Input('dstMatColumnResize') widthPx = 0;
  @Output() widthChange = new EventEmitter<number>();

  private resizing = false;
  private startX = 0;
  private startWidth = 0;

  @HostListener('mousedown', ['$event'])
  onMouseDown(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!target.classList.contains('dst-mat-col-resize-handle')) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    this.resizing = true;
    this.startX = event.pageX;
    this.startWidth = this.widthPx || this.elementRef.nativeElement.offsetWidth;
    document.addEventListener('mousemove', this.onMouseMove);
    document.addEventListener('mouseup', this.onMouseUp);
  }

  private onMouseMove = (event: MouseEvent): void => {
    if (!this.resizing) {
      return;
    }
    const delta = event.pageX - this.startX;
    const nextWidth = Math.max(60, this.startWidth + delta);
    this.widthChange.emit(nextWidth);
  };

  private onMouseUp = (): void => {
    this.resizing = false;
    document.removeEventListener('mousemove', this.onMouseMove);
    document.removeEventListener('mouseup', this.onMouseUp);
  };
}
